import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { MarketingShell } from "./components/MarketingShell";
import { ShortlistBar } from "./components/ShortlistBar";
import { MarketingHome } from "./pages/MarketingHome";
import { MarketingProperties } from "./pages/MarketingProperties";
import { MarketingListing } from "./pages/MarketingListing";
import { MarketingAbout } from "./pages/MarketingAbout";
import { MarketingPrivacy } from "./pages/MarketingPrivacy";

// The public PropertyMakers marketing site (SPA). Mounted at the marketing host
// root; owns its own sub-routes. Replaces the old Clozdl LandingPage.
export default function MarketingSite() {
  return (
    <MarketingShell>
      <Routes>
        <Route path="/" element={<MarketingHome />} />
        <Route path="/properties" element={<MarketingProperties />} />
        <Route path="/properties/:citySlug" element={<MarketingProperties />} />
        <Route path="/properties/:citySlug/:state" element={<MarketingProperties />} />
        <Route path="/p/:token" element={<MarketingListing />} />
        <Route path="/about" element={<MarketingAbout />} />
        <Route path="/privacypolicy" element={<MarketingPrivacy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ShortlistBar />
    </MarketingShell>
  );
}
